(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("keyapis", [], factory);
	else if(typeof exports === 'object')
		exports["keyapis"] = factory();
	else
		root["keyapis"] = factory();
})(this, () => {
return 